import { PrinterError } from '@lib/utils/printerUtils'

export const TRANSLATIONS_MAPPER = {
  PROCESSING: {
    identification: 'estamos_iniciando_tu_sesion',
    coupon: 'estamos_validando_tu_cupon'
  },
  PICKUP_BUTTON: {
    eatin: 'para_comer_aqui',
    takeout: 'para_llevar'
  },
  HOME_MENU: {
    home: 'inicio',
    loyalty: 'mimcdonalds',
    'aop-coupon': 'cupones'
  },
  PRODUCT: {
    SIZES: {
      SMALL: 'pequeno',
      MEDIUM: 'mediano',
      LARGE: 'grande',
      NONE: 'a_la_carta'
    },
    OPTION_GROUPS: {
      CHOICE_GROUP: {
        TOY: { main: 'elige_tu_juguete', product: 'juguete' },
        DESSERT: { main: 'elige_tu_postre', product: 'postre' },
        DRINK: { main: 'elige_tu_bebida', product: 'bebida' },
        SIDE: { main: 'elige_tu_acompanamiento', product: 'acompanamiento' },
        CONDIMENT: { main: 'elige_tu_salsa', product: 'salsa' },
        SAUCE: { main: 'elige_tu_salsa', product: 'salsa' },
        DRESSING: { main: 'elige_tu_salsa', product: 'salsa' }
      }
    }
  },
  FORM: {
    FISCAL: {
      document: 'numero_de_documento',
      type: 'tipo_de_documento',
      name: 'nombre_y_apellido',
      email: 'email'
    }
  },
  MODAL: {
    IDENTIFICATION: {
      identificationError: {
        title: 'no_pudimos_iniciar_tu_sesion',
        description: 'intentalo_de_nuevo'
      },
      identificationUpgradingError: {
        title: 'no_pudimos_completar_tu_inicio_de_sesion',
        description: 'intentalo_de_nuevo'
      },
      unauthorized: {
        title: 'se_cerro_tu_sesion',
        description: 'escanea_tu_qr_para_volver_a_ingresar_a_tu_cuenta'
      }
    },
    OTP: {
      requestError: {
        title: 'no_pudimos_enviarte_el_codigo',
        description: 'intentalo_de_nuevo'
      },
      confirmError: {
        title: 'no_pudimos_validar_tu_codigo',
        description: 'intentalo_de_nuevo'
      }
    },
    COUPON: {
      aopCouponError: {
        title: 'no_pudimos_aplicar_este_cupon',
        description: 'intentalo_de_nuevo_o_usa_otro_cupon'
      },
      aopCouponAlreadyUsed: {
        title: 'ya_usaste_este_cupon',
        description: 'intentalo_con_otro'
      },
      aopCouponExpired: {
        title: 'este_cupon_ya_no_esta_diponible',
        description: 'intentalo_con_otro'
      },
      aopCouponWithoutSession: {
        title: 'elige_como_quieres_tu_pedido',
        description:
          'antes_de_escanear_tu_cupon_selecciona_si_tu_pedido_es_para_comer_aqui_o_para_llevar'
      }
    },
    CHECKOUT: {
      checkoutGeneric: {
        title: 'algo_salio_mal',
        description: 'no_pudimos_completar_tu_pedido_intentalo_nuevamente'
      },
      checkoutFlexGeneric: {
        title: 'algo_salio_mal',
        description: 'no_pudimos_completar_tu_pedido_intentalo_nuevamente'
      },
      checkoutOutage: {
        title: 'hay_productos_en_tu_carrito_que_ya_no_estan_disponibles',
        description: 'revisa_tu_pedido_para_continuar_con_tu_compra'
      },
      checkoutPaymentErrorSomethingWrong: {
        title: 'no_pudimos_completar_el_pago',
        description: 'intentalo_de_nuevo_o_prueba_con_otra_tarjeta'
      },
      checkoutPaymentErrorCantFinish: {
        title: 'algo_salio_mal',
        description:
          'este_metodo_de_pago_no_esta_disponible_por_el_momento_acercate_al_mostrador_para_completar_el_pedido'
      }
    },
    CART: {
      addToCart: {
        title: 'agregaste_el_producto_al_carrito',
        description: 'total_de_tu_pedido'
      }
    }
  },
  INOPERATIVE: {
    TITLE: 'inoperativo',
    DESCRIPTION:
      'parece_que_este_quiosco_no_esta_disponible_actualmente_utilice_otro_punto_de_pedido_para_realizar_un_pedido',
    PRINTER: {
      REASON: 'razon_impresora',
      ERRORS: {
        [PrinterError.DISCONNECTED]: 'impresora_desconectada_o_no_disponible_en_la_red',
        [PrinterError.OPEN_DECK]: 'la_puerta_de_la_impresora_esta_abierta',
        [PrinterError.NO_PAPER]: 'no_queda_papel_en_la_impresora',
        [PrinterError.LOW_PAPER]: 'hay_poco_papel_en_la_impresora'
      }
    }
  },
  TICKET: {
    DESCRIPTION_OK: {
      inperson: 'retira_tu_ticket_y_presentate_en_el_mostrador_para_completar_el_pago',
      mop: 'presenta_el_ticket_en_el_mostrador_para_recibir_tu_pedido',
      ealm: 'ya_puedes_retirar_tu_ticket'
    }
  },
  THANK_YOU: {
    DESCRIPTION: {
      inperson: 'presenta_tu_ticket_en_el_mostrador_para_completar_el_pago',
      mop: 'una_persona_de_nuestro_equipo_te_entregara_el_pedido_en_el_mostrador',
      ealm: 'una_persona_de_nuestro_equipo_llevara_el_pedido_a_tu_mesa'
    },
    NEXT_STEPS: {
      'take-ticket': 'retira_el_ticket',
      'pay-at-counter': 'paga_en_el_mostrador',
      'takeout-receive-at-counter': 'recibe_tu_pedido',
      'eatin-receive-at-counter': 'recibe_tu_pedido',
      'put-table-tent': 'coloca_el_localizador_en_la_mesa',
      'bring-to-the-table': 'recibe_tu_pedido'
    }
  },
  LANGUAGE: {
    spanish: 'espanol',
    english: 'ingles'
  }
} as const
